import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

export const Base = props => {

  const { name, children, setTitle } = props
  const [ isLoading, loading ] = useState(true)

  useEffect(() => {

    loading(false)

    if (setTitle) setTitle(name)

  }, [name])

  return (<>
    { isLoading ? 
        <>Loading {name}...</>
      :
        <div className={`base ${name}`}>
          {children}
        </div>
    }
  </>)
}
